import React from "react";
import Login from "../components/auth/Login";
import { Helmet, HelmetProvider } from "react-helmet-async";

export default function LoginPage() {
  return (
    <div>
      <HelmetProvider>
        <Helmet>
          <title>Vistaflow connexion</title>
        </Helmet>
      </HelmetProvider>
      <Login />
    </div>
  );
}
